import React, { useState } from 'react';
import OptimizationObjectivesTable from './OptimizationObjectives';

export const initialGoals = [
    {
        id: 1,
        structure: 'Brainstem',
        volumePrecent: 25,
        dose: 54,
        priority: 1000,
        gEUD: 52,
        expanded: false,
        subRows: [
            {
                type: 'Max Dose',
                volumePrecent: 20,
                dose: 32,
                priority: 1000,
                gEUD: 49,
            },
            {
                type: 'Mean Dose',
                volumePrecent: 10,
                dose: 23,
                priority: 500,
                gEUD: 44,
            },
        ],
    },
    {
        id: 2,
        structure: 'Spinal Cord',
        volumePrecent: 18,
        dose: 12,
        priority: 500,
        gEUD: 43,
        expanded: false,
        subRows: [
            {
                type: 'Max Dose',
                volumePrecent: 15,
                dose: 56,
                priority: 500,
                gEUD: 42,
            },
        ],
    },
    {
        id: 3,
        structure: 'Lung',
        volumePrecent: 30,
        dose: 45,
        priority: 0,
        gEUD: 58,
        expanded: false,
        subRows: [],
    },
    {
        id: 4,
        structure: 'Heart',
        volumePrecent: 35,
        dose: 34,
        priority: 500,
        gEUD: 28,
        expanded: false,
        subRows: [
            {
                type: 'Mean Dose',
                volumePrecent: 15,
                dose: 41,
                priority: 500,
                gEUD: 27,
            },
        ],
    },
    {
        id: 5,
        structure: 'Liver',
        volumePrecent: 40,
        dose: 27,
        priority: 1000,
        gEUD: 53,
        expanded: false,
        subRows: [
            {
                type: 'Max Dose',
                volumePrecent: 25,
                dose: 11,
                priority: 1000,
                gEUD: 50,
            },
            {
                type: 'Mean Dose',
                volumePrecent: 20,
                dose: 15,
                priority: 500,
                gEUD: 48,
            },
        ],
    },
    {
        id: 6,
        structure: 'Kidney',
        volumePrecent: 20,
        dose: 60,
        priority: 0,
        gEUD: 45,
        expanded: false,
        subRows: [
            {
                type: 'Max Dose',
                volumePrecent: 18,
                dose: 54,
                priority: 0,
                gEUD: 46,
            },
        ],
    },
];

const OptimizationObjectivesComponent: React.FC = () => {
    const [rows, setRows] = useState(initialGoals);
    const [checkedRows, setCheckedRows] = useState<boolean[]>(
        initialGoals.map(() => false)
    );

    const handleExpand = (rowId: number) => {
        setRows((prevRows) =>
            prevRows.map((row) =>
                row.id === rowId ? { ...row, expanded: !row.expanded } : row
            )
        );
    };

    const handleCheckboxChange = (index: number) => {
        const newCheckedRows = [...checkedRows];
        newCheckedRows[index] = !newCheckedRows[index];
        setCheckedRows(newCheckedRows);
    };

    return (
        <OptimizationObjectivesTable
            rows={rows}
            onExpand={handleExpand}
            onCheckboxChange={handleCheckboxChange}
            checkedRows={checkedRows}
        />
    );
};

export default OptimizationObjectivesComponent;
